export default __webpack_public_path__ + "static/media/team-control-about.ceda6519.svg";